import { useState } from 'react'
import { modalKeys } from '../constants/modalKeys'
import { useAppSelector } from '../hooks'
import { selectModal } from '../store/slices/modal.slice'
import { CookiesPopup } from './CookiesPopup'
import { ShutdownNoticeModal } from './Modals/ShutdownNoticeModal'
import { SHUTDOWN_NOTICE_LS_KEY } from '../constants/shutdownNotice'
import { AuthenticationModal } from './Modals/AuthenticationModal/AuthenticationModal'
import { ConnectWalletModal } from './Modals/ConnectWalletModal'
import { RequireChain } from './RequireChain/RequireChain'
import { useIsMobile } from '../hooks/useIsMobile'
import { MobileMenuWalletConnect } from './MobileMenuWalletConnect/MobileMenuWalletConnect'
import { MobileMenuConnectedWallets } from './MobileMenuConnectedWallets/MobileMenuConnectedWallets'

export const GlobalModals = () => {
  const { isMobile } = useIsMobile()
  const [showCookiePopup, setShowCookiePopup] = useState(localStorage.getItem('cookies-confirmed') === null)
  const [showShutdownNotice, setShowShutdownNotice] = useState(localStorage.getItem(SHUTDOWN_NOTICE_LS_KEY) === null)
  const modal = useAppSelector(selectModal)

  const toggleCookiePopup = () => {
    setShowCookiePopup(!showCookiePopup)
  }

  const dismissShutdownNotice = () => {
    localStorage.setItem(SHUTDOWN_NOTICE_LS_KEY, 'true')
    setShowShutdownNotice(false)
  }

  return (
    <>
      <RequireChain />
      {/* Modal shown */}
      <AuthenticationModal />
      {modal.modalShown === modalKeys.connectWallet &&
        (isMobile ? <MobileMenuWalletConnect /> : <ConnectWalletModal />)}
      {modal.modalShown === modalKeys.connectedWalletsMobile && isMobile && <MobileMenuConnectedWallets />}
      {showCookiePopup && !showShutdownNotice && modal.modalShown !== modalKeys.connectWallet && (
        <CookiesPopup toggleCookiePopup={toggleCookiePopup} />
      )}
      {showShutdownNotice && <ShutdownNoticeModal isVisible={showShutdownNotice} onClose={dismissShutdownNotice} />}
    </>
  )
}
